export interface CrudFormConfigValidators {
  name: string;
  validatorKey: string;
  params?: any;
}
